import * as React from "react";
import { MdDone } from "react-icons/md";
import { Translate } from "react-localize-redux";
import { Link } from "react-router-dom";
import "./StepperMobile.scss";

interface IProps {
  current: 1 | 2 | 3; // The current step
  finishedEnabled?: boolean;
  isContactRequest?: boolean;
  summaryEnabled?: boolean;
}
class StepperMobile extends React.Component<IProps, {}> {
  public render() {
    return (
      <div className="d-block d-md-none stepperMobile d-flex flex-wrap justify-content-between mt-3">
        <Link className={"btn col-auto step d-flex flex-column align-items-center " + (this.props.current === 1 ? "active " : this.props.current > 1 ? "done" : "")} to="/">
          {this.props.current > 1 ? <MdDone /> : <span className="number">1</span>}
          <span className="name mt-2">
            <Translate id="SOP" />
          </span>
        </Link>
        <div className="line flex-fill mx-1" />
        {(this.props.isContactRequest) && (
          <Link className={"btn col-auto step d-flex flex-column align-items-center"} to="/contactRequest">
            {this.props.current > 2 ? <MdDone /> : <span className="number">2</span>}
            <span className="name mt-2">
              <Translate id="Contacts" />
            </span>
          </Link>
        )}
        {(!this.props.isContactRequest) && (
          <Link className={"btn col-auto step d-flex flex-column align-items-center " + (this.props.current === 2 ? "active " : this.props.current > 2 ? "done" : "") + (!this.props.summaryEnabled ? " disabled" : "")} to="/summary">
            {this.props.current > 2 ? <MdDone /> : <span className="number">2</span>}
            <span className="name mt-2">
              <Translate id="Contacts" />
            </span>
          </Link>
        )}
        <div className="line flex-fill mx-1" />
        <Link className={"btn col-auto step d-flex flex-column align-items-center " + (this.props.current === 3 ? "active " : "") + (!this.props.finishedEnabled ? " disabled" : "")} to="/finished">
          <span className="number">3</span>
          <span className="name mt-2">
            <Translate id="Finished" />
          </span>
        </Link>
      </div>
    );
  }
}

export default StepperMobile;
